import React, { createContext, useContext, useState, useCallback } from 'react';

const CreateAdContext = createContext(null);

export const CreateAdProvider = ({ children }) => {
  const [pendingActions, setPendingActions] = useState([]);
  const [submitSignal, setSubmitSignal] = useState(0);
  // Partagé entre CreateAd et son en-tête (extrait dans CreateAdWithAI en
  // mode IA pour que le panneau de chat s'aligne pile avec le formulaire —
  // sinon l'en-tête de CreateAd (titre/bascule) créait un décalage vertical
  // entre les deux colonnes).
  const [isSimpleCampaign, setIsSimpleCampaign] = useState(true);

  const dispatchActions = useCallback((actions) => {
    if (Array.isArray(actions) && actions.length > 0) {
      setPendingActions([...actions]);
    }
  }, []);

  const clearActions = useCallback(() => {
    setPendingActions([]);
  }, []);

  const requestSubmit = useCallback(() => {
    setSubmitSignal((s) => s + 1);
  }, []);

  return (
    <CreateAdContext.Provider value={{ pendingActions, dispatchActions, clearActions, submitSignal, requestSubmit, isSimpleCampaign, setIsSimpleCampaign }}>
      {children}
    </CreateAdContext.Provider>
  );
};

const NO_OP_CTX = {
  pendingActions: [],
  dispatchActions: () => {},
  clearActions: () => {},
  submitSignal: 0,
  requestSubmit: () => {},
  isSimpleCampaign: true,
  setIsSimpleCampaign: () => {},
};

export const useCreateAdContext = () => {
  return useContext(CreateAdContext) || NO_OP_CTX;
};

export default CreateAdContext;
